// A table row's summary (the row-click tables, DataTable's onRowClick): the row's facts as a <dl>,
// anything more the screen shows (children), and the actions that used to sit at the end of the
// row (Approve, Revoke, …). Destructive actions still confirm in their own ConfirmDialog. Close is
// always offered; the actions go before it.
import type { ComponentChildren } from "preact";
import { Dialog } from "./dialog";

export interface RowFact {
  label: string;
  value: ComponentChildren;
}

export interface RowDetailProps {
  title: string;
  open: boolean;
  onClose(): void;
  facts: readonly RowFact[];
  /** The row's actions; omitted or empty when there are none (a read-only row). */
  actions?: ComponentChildren;
  children?: ComponentChildren;
  /** Extra class on the dialog (`dialog-wide` for a long summary). */
  class?: string;
}

export function RowDetail({ title, open, onClose, facts, actions, children, class: className }: RowDetailProps) {
  return (
    <Dialog
      title={title}
      open={open}
      onClose={onClose}
      class={className ? `row-detail ${className}` : "row-detail"}
      actions={
        <>
          {actions}
          <button type="button" class="button button-secondary" onClick={onClose}>
            Close
          </button>
        </>
      }
    >
      <dl class="row-detail-facts">
        {facts.map((fact) => (
          <div key={fact.label}>
            <dt>{fact.label}</dt>
            <dd>{fact.value}</dd>
          </div>
        ))}
      </dl>
      {children}
    </Dialog>
  );
}
